export class VATSettingsModel {
  vatRegistrationNo: string;
  vatRegistrationDate: Date;
  vatSchemeId: number;
  vatReturnTypeId: number;
}
